import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";


const CancellationPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Cancellation Policy | Halo Holidays</title>
          <meta name="description" content="Learn about our cancellation policy, conditions, and procedures for modifying or canceling your reservations." />
        </Helmet>
      </HelmetProvider>

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-semibold text-center">Cancellation Policy</h1>
        <hr className="mb-10 mt-5" />
        <p className="text-[1rem] text-gray-700 mb-8">
        <strong className="text-black">Cancellations:</strong> You may cancel your booking at any time. Cancellation requests must be sent to us in writing to Customer Services, Halo Holidays, 15A Cobalt Business Park, 1 Quick Silver Way, Newcastle upon Tyne, London NE27 0QQ, United Kingdom, or by email to : <a href="mailto:contact@haloholidays.co.uk" className="text-halo-pink hover:text-[#116FFF] hover:underline">contact@haloholidays.co.uk</a> by the lead name on your booking and it will not take effect until received by us. Upon receipt of your cancellation request, the principal(s) or supplier(s) may be entitled to charge a cancellation fee. Cancellation fees may be as much as 100% of the total price of the travel service depending on when cancellation occurs. Bookings are usually non-refundable unless stated otherwise any time after the date of booking. In addition, as we incur administration costs in processing your cancellation request, we charge an administration fee of £ 85 per passenger.
        </p>

        <p className="text-[1rem] mb-2 mt-2 text-gray-700">
          <strong className="text-black">Amendments:</strong> If you want to amend any aspect of your booking you must notify us in writing by post at Customer Services, Halo Holidays, 15A Cobalt Business Park, 1 Quick Silver Way, Newcastle upon Tyne, London NE27 0QQ, United Kingdom or email to <a href="mailto:contact@haloholidays.co.uk" className="text-halo-pink hover:text-[#116FFF] hover:underline">contact@haloholidays.co.uk</a>. We cannot guarantee that an amendment can be made after your booking is confirmed and this will depend on the terms and conditions of the supplier(s) of the travel service(s). Other than in respect of a request to increase the number of persons in your party/booking, you would need to pay an amendment fee of £ 85 per passenger, together with the airline/supplier amendment charges (if any). If you have taken out travel insurance (see Clause 7 below), you may be able to claim any cancellation and amendment charges under your policy.
        </p>
      </div>
    </>
  );
};

export default CancellationPolicy;
